var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 2C17.75 2.31984 17.6279 2.63984 17.3838 2.88359L7.38379 12.8836C7.14062 13.1289 6.82031 13.25 6.5 13.25C6.17969 13.25 5.86016 13.1279 5.61641 12.8838L0.616406 7.88379C0.372266 7.64062 0.25 7.32031 0.25 7C0.25 6.28594 0.833984 5.75 1.5 5.75C1.81984 5.75 2.13984 5.87207 2.38359 6.11621L6.5 10.2344L15.6172 1.11719C15.8594 0.872266 16.1797 0.75 16.5 0.75C17.168 0.75 17.75 1.28516 17.75 2Z",
    fill: "black",
    fillOpacity: 0.38
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCheck);
export default __webpack_public_path__ + "static/media/payment-check.10bd6a2a877480f1aab03cafeadfe9f0.svg";
export { ForwardRef as ReactComponent };